import { __values } from "tslib";
import { logPerformanceEvent } from '../wrappers/logPerformanceEvent';
import { getBrowserTimingMeasures } from './getBrowserTimingMeasures';
import { logPerformanceError } from './logPerformanceError';
var dumpedBrowserMarkers = false;
export function dumpBrowserMarkers(cdnDomain, resourceLoggingEnabled, globalParams) {
    var e_1, _a;
    if (dumpedBrowserMarkers) {
        return;
    }
    // Measure time for CDN asset which takes the longest to download
    if (resourceLoggingEnabled && cdnDomain) {
        // This regex will make sure we measure the files served from our OfficeHome CDN.
        // initiatorType === 'script' makes sure we get from <script> elements
        // TODO: measure shell download latency as well
        var cdnRegex_1 = new RegExp("https://" + cdnDomain + ".*", 'i');
        var resourceTimingEntries = window.performance.getEntriesByType('resource')
            .filter(function (entry) {
            return cdnRegex_1.test(entry.name) &&
                (entry.initiatorType === 'script' ||
                    entry.initiatorType === 'link');
        })
            .filter(function (entry) {
            // Cached assets will have transferSize of 0.
            // However, the transferSize property is not widely supported yet, so instead use a heuristic
            // to determine if asset is cached if transferSize is not available.
            if (entry.hasOwnProperty('transferSize')) {
                return entry.transferSize > 0;
            }
            else {
                var transferTimeMs = entry.responseEnd - entry.responseStart;
                return transferTimeMs > 20;
            }
        });
        // Identify the resource from CDN that takes the longest to complete 'responseEnd'
        var maxResponseEndResourceTimingEntry = void 0;
        var max = 0;
        try {
            for (var resourceTimingEntries_1 = __values(resourceTimingEntries), resourceTimingEntries_1_1 = resourceTimingEntries_1.next(); !resourceTimingEntries_1_1.done; resourceTimingEntries_1_1 = resourceTimingEntries_1.next()) {
                var resourceTimingEntry = resourceTimingEntries_1_1.value;
                // These are the markers we want for each resource
                var timingEntry = resourceTimingEntry["responseEnd" /* ResponseEnd */];
                if (typeof timingEntry === 'number' && timingEntry > 0) {
                    if (timingEntry > max) {
                        max = timingEntry;
                        maxResponseEndResourceTimingEntry = resourceTimingEntry;
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (resourceTimingEntries_1_1 && !resourceTimingEntries_1_1.done && (_a = resourceTimingEntries_1.return)) _a.call(resourceTimingEntries_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (maxResponseEndResourceTimingEntry) {
            var filename = maxResponseEndResourceTimingEntry.name
                .split('/')
                .pop();
            var marker = 'Last_CDN_Script_Downloaded';
            var responseEnd = maxResponseEndResourceTimingEntry.responseEnd;
            var params = globalParams || {};
            params["Filename" /* Filename */] = filename || '';
            logPerformanceEvent(marker, responseEnd, params);
        }
    }
    var browserTimingMeasures = getBrowserTimingMeasures(function (name, error) {
        logPerformanceError(name, error);
    }, globalParams);
    browserTimingMeasures.forEach(function (measure) {
        logPerformanceEvent(measure.name, measure.duration, measure.params);
    });
    dumpedBrowserMarkers = true;
}
//# sourceMappingURL=dumpBrowserMarkers.js.map